import { Box } from "@saleor/macaw-ui-next";
import * as React from "react";

interface ListPageLayoutProps {
  children: React.ReactNode;
  hasSaveBar?: boolean;
  hasTopNav?: boolean;
}

export const ListPageLayout = ({ children }: ListPageLayoutProps) => (
  <Box
    display="grid"
    // minmax(0, 1fr) so wide children (headers, grids) cannot stretch the page past the viewport
    __gridTemplateColumns="minmax(0, 1fr)"
    __gridTemplateRows="auto 1fr"
    height="100%"
  >
    {children}
  </Box>
);
